export enum SeriesType {
  Area = 0,
  Bar = 1,
  Line = 2,
}
